<template>
  <div>
    <div class="title">在线留言</div>
    <div class="content">
      <div class="content-info">
        <div class="item">
          <label for>姓名：</label>
          <Input v-model="name" style="width:200px" />
        </div>
        <div class="item">
          <label for>手机号码：</label>
          <Input v-model="phone" style="width:200px" maxlength="11" type="tel" />
        </div>
        <div class="item">
          <label for>留言：</label>
          <Input v-model="message" style="width:400px" type="textarea" />
        </div>
        <div class="btn">
          <Button type="primary" size="large">提交留言</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      phone: "",
      message: "",
    };
  },
};
</script>

<style scoped lang="less">
.title {
  height: 55px;
  line-height: 55px;
  font-size: 28px;
  border-bottom: 1px solid #dbd4cd;
  color: #2d8cf0;
  padding: 0;
  text-align: left;
}
.content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-info {
  width: 500px;
  padding-top: 50px;
}
label {
  display: block;
  width: 100px;
}
.item {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.btn {
  text-align: center;
  padding-top: 50px;
}
</style>